import InviteUserModal from './inviteUserModal'

export default InviteUserModal
